import { Table, Group } from '@mantine/core';
import { IconChevronUp, IconChevronDown, IconSelector } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface SortableHeaderProps {
  column: string;
  sortColumn: string | null;
  sortDirection: 'asc' | 'desc';
  onSort: (column: string) => void;
  children: ReactNode;
  w?: number;
}

export function SortableHeader({
  column,
  sortColumn,
  sortDirection,
  onSort,
  children,
  w,
}: SortableHeaderProps) {
  const isSorted = sortColumn === column;

  return (
    <Table.Th
      onClick={() => onSort(column)}
      style={{ cursor: 'pointer', userSelect: 'none' }}
      w={w}
    >
      <Group gap={4} wrap="nowrap">
        {children}
        {isSorted ? (
          sortDirection === 'asc' ? (
            <IconChevronUp size={14} />
          ) : (
            <IconChevronDown size={14} />
          )
        ) : (
          <IconSelector size={14} style={{ opacity: 0.3 }} />
        )}
      </Group>
    </Table.Th>
  );
}
